/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input'
import 'owl.carousel'
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import { setHrefs } from './functions/data-hrefs'
import { initEqualizeContent } from './functions/equalizer'
import { initTelephoneInput } from './functions/intl-tel-input'
import { initDatepickerInput } from './functions/datepicker'
import { enableNegativeMargins } from './functions/negative-margins'
import { mapStyles } from './functions/map-styles'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/villahomesrgv_v2"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"
Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination, Autoplay])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function(){
	jQuery(document).foundation();
	triggerThemeFunctions();

	let tag = document.createElement('script');

	tag.src = "https://www.youtube.com/iframe_api";
	let firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	// ADD YOUR CODE HERE
	// 
	//
	function singlePropertyGalleryFunction() {
		// SINGLE PROPERTY GALLERY
		// reference for main items
		var singlePropertyCarousel = jQuery('#single-property-carousel');
		// reference for thumbnail items
		var singlePropertyThumbnailCarousel = jQuery('#single-property-carousel-thumbs');
		//transition time in ms
		var duration = 300;


		singlePropertyCarousel.owlCarousel({
			loop: false,
			margin: 0,
			nav: false,
			dots: false,
			autoplay: true,
			autoplayTimeout: 15000,
			autoHeight: true,
			responsive: {
				0: {
					items: 1
				},
				300: {
					items: 1
				},
				600: {
					items: 1
				},
				900: {
					items: 1
				},
				1200: {
					items: 1
				},
				1440: {
					items: 1
				}
			}
		}).on('changed.owl.carousel', function (e) {
			//On change of main item to trigger thumbnail item
			singlePropertyThumbnailCarousel.trigger('to.owl.carousel', [e.item.index, duration, true]);
			singlePropertyThumbnailCarousel.find('.current').removeClass('current');
			var index = e.item.index;
			var offset = jQuery(e.target).find('.active:first').prevAll('.cloned').length;
			singlePropertyThumbnailCarousel.find('.owl-item').eq(index - offset).addClass('current');
		});

		singlePropertyThumbnailCarousel.owlCarousel({
			loop: false,
			margin: 24,
			nav: false,
			dots: false,
			autoplay: false,
			responsive: {
				0: {
					items: 2
				},
				300: {
					items: 2
				},
				600: {
					items: 3
				},
				900: {
					items: 4
				},
				1200: {
					items: 4
				},
				1440: {
					items: 4
				}
			}
		}).on('click', '.owl-item', function () {
			// On click of thumbnail items to trigger same main item
			singlePropertyCarousel.trigger('to.owl.carousel', [jQuery(this).index(), duration, true]);
			singlePropertyThumbnailCarousel.find('.current').removeClass('current');
			jQuery(this).addClass('current');

		}).on('changed.owl.carousel', function (e) {
			// On change of thumbnail item to trigger main item
			singlePropertyCarousel.trigger('to.owl.carousel', [e.item.index, duration, true]);
		});

		singlePropertyThumbnailCarousel.find('.owl-item').first().addClass('current');

		jQuery('#singlePropertyCarouselRight').click(function () {
			singlePropertyCarousel.trigger('next.owl.carousel');
		});
		jQuery('#singlePropertyCarouselLeft').click(function () {
			singlePropertyCarousel.trigger('prev.owl.carousel');
		});
	}
	
	var gallerySwiper = new Swiper(".home-gallery-swiper", {
		direction: 'horizontal',
			spaceBetween: 20,
			slidesPerView: 1,
		navigation: {
		nextEl: '.home-gallery-swiper-container .custom-next',
		prevEl: '.home-gallery-swiper-container .custom-prev',
		},
			loop: true,
			speed: 3000,
			// autoplay: {
			// 	delay: 0,
			// 	disableOnInteraction: false,
			// },
			breakpoints: {
				640: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1440: {
					slidesPerView: 2,
					spaceBetween: 30,
				}
			},
			on: {
				init: function () {
					setTimeout(function() {
						window.dispatchEvent(new Event('resize'));
					}, 500);
				},
			},
		});

	var homesForSaleSwiper = new Swiper(".homes-for-sale-swiper", {
		direction: 'horizontal',
			spaceBetween: 20,
			slidesPerView: 1,
		navigation: {
		nextEl: '.homes-for-sale-swiper .custom-next',
		prevEl: '.homes-for-sale-swiper .custom-prev',
		},
			loop: true,
			speed: 3000,
			// autoplay: {
			// 	delay: 0,
			// 	disableOnInteraction: false,
			// },
			breakpoints: {
				640: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1440: {
					slidesPerView: 2,
					spaceBetween: 30,
				}
			},
		});

		var portfolioSwiper = new Swiper(".portfolio-swiper", {
			direction: 'horizontal',
				spaceBetween: 20,
				slidesPerView: 1,
			navigation: {
			nextEl: '#portfolio-swiper-container-custom-next',
			prevEl: '#portfolio-swiper-container-custom-prev',
			},
				loop: true,
				speed: 3000,
				// autoplay: {
				// 	delay: 0,
				// 	disableOnInteraction: false,
				// },
				breakpoints: {
					640: {
						slidesPerView: 1,
						spaceBetween: 20,
					},
					1024: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
					1200: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
					1440: {
						slidesPerView: 2,
						spaceBetween: 30,
					}
				},
				on: {
					init: function () {
						setTimeout(function() {
							window.dispatchEvent(new Event('resize'));
						}, 500);
					},
				},
			});

		var homesForSaleSubdivisionsSwiper = new Swiper(".homes-for-sale-subdivisions-swiper", {
			direction: 'horizontal',
				spaceBetween: 20,
				slidesPerView: 1,
			navigation: {
			nextEl: '.homes-for-sale-subdivisions-swiper .custom-next',
			prevEl: '.homes-for-sale-subdivisions-swiper .custom-prev',
			},
				loop: true,
				speed: 3000,
				// autoplay: {
				// 	delay: 0,
				// 	disableOnInteraction: false,
				// },
				breakpoints: {
					640: {
						slidesPerView: 1,
						spaceBetween: 20,
					},
					1024: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
					1200: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
					1440: {
						slidesPerView: 2,
						spaceBetween: 30,
					}
				},
				on: {
					init: function () {
						setTimeout(function() {
							window.dispatchEvent(new Event('resize'));
						}, 500);
					},
				},
			});


	var neighborhoodSwiper = new Swiper(".neighborhoods-swiper", {
		direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 1,
		navigation: {
			nextEl: '.neighborhoods-swiper-container .custom-next',
			prevEl: '.neighborhoods-swiper-container .custom-prev',
		},
			loop: true,
			speed: 3000,
			// autoplay: {
			// 	delay: 0,
			// 	disableOnInteraction: false,
			// },
			breakpoints: {
				640: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
				1440: {
					slidesPerView: 3,
					spaceBetween: 30,
				}
			},
			on: {
				init: function () {
					setTimeout(function() {
						window.dispatchEvent(new Event('resize'));
					}, 500);
				},
			},
		});

		var subdivisionSwiperLeft = new Swiper(".subdivision-swiper", {
			direction: 'horizontal',
				// spaceBetween: 20,
				slidesPerView: 1,
		navigation: {
				nextEl: '.subdivision-swiper-container .custom-next',
				prevEl: '.subdivision-swiper-container .custom-prev',
			},
				loop: true,
				speed: 3000,
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
				},
				breakpoints: {
					640: {
						slidesPerView: 1,
						// spaceBetween: 20,
					},
					1024: {
						slidesPerView: 1,
						// spaceBetween: 30,
					},
					1200: {
						slidesPerView: 1,
						// spaceBetween: 30,
					},
					1440: {
						slidesPerView: 1,
						// spaceBetween: 30,
					}
				},
				on: {
					init: function () {
						setTimeout(function() {
							window.dispatchEvent(new Event('resize'));
						}, 500);
					},
				},
			});

			var subdivisionSwiperRight = new Swiper(".subdivision-swiper-right", {
				direction: 'horizontal',
					// spaceBetween: 20,
					slidesPerView: 1,
			navigation: {
					nextEl: '.subdivision-swiper-container-right .custom-next',
					prevEl: '.subdivision-swiper-container-right .custom-prev',
				},
					loop: true,
					speed: 3000,
					autoplay: {
						delay: 5000,
						disableOnInteraction: false,
					},
					breakpoints: {
						640: {
							slidesPerView: 1,
							// spaceBetween: 20,
						},
						1024: {
							slidesPerView: 1,
							// spaceBetween: 30,
						},
						1200: {
							slidesPerView: 1,
							// spaceBetween: 30,
						},
						1440: {
							slidesPerView: 1,
							// spaceBetween: 30,
						}
					},
					on: {
						init: function () {
							setTimeout(function() {
								window.dispatchEvent(new Event('resize'));
							}, 500);
						},
					},
				});

	// Two testimonials already fill both columns on large, so the arrows have
	// nothing to navigate to. Recalculated on every breakpoint change, and it
	// counts the real slides - add a third testimonial and the arrows and
	// dragging come back on their own.
	function toggleTestimonialNavigation(swiper) {
		let container = jQuery('.testimonials-swiper-container');

		if (!container.length) {
			return;
		}

		let slides = container.find('.swiper-slide').not('.swiper-slide-duplicate').length;
		let perView = swiper.params.slidesPerView;
		let allVisible = typeof perView === 'number' && slides <= perView;

		container.toggleClass('navigation-hidden', allVisible);
		swiper.allowTouchMove = !allVisible;
	}

	var testimonialSwiper = new Swiper(".testimonials-swiper", {
		direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 1,
		navigation: {
			nextEl: '.testimonials-swiper-container .custom-next',
			prevEl: '.testimonials-swiper-container .custom-prev',
		},
		loop: true,
		speed: 3000,
		// autoplay: {
		// 	delay: 0,
		// 	disableOnInteraction: false,
		// },
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 2,
				spaceBetween: 30,
			}
		},
		on: {
			init: function () {
				setTimeout(function() {
					window.dispatchEvent(new Event('resize'));
				}, 500);
				toggleTestimonialNavigation(this);
			},
			breakpoint: function () {
				toggleTestimonialNavigation(this);
			},
		},
	});

	if(testimonialSwiper) {
		jQuery('.testimonials-swiper .testimonial-box').each(function() {
			let testimonial_id = jQuery(this).data('testimonial-id');

			jQuery('#videoOverlay-' + testimonial_id).click(function() {
				let container = jQuery('#videoContainer-' + testimonial_id);
				let iframe = container.find('iframe');
				let src = iframe.attr('data-src');

				// The iframe ships with data-src only, so nothing loads until
				// the visitor asks for it. Adding autoplay here means this
				// click starts the video instead of just revealing the player.
				if (src && !iframe.attr('src')) {
					iframe.attr('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1&rel=0');
				}

				jQuery(this).hide();
				container.show();
			});
		});
	}


	var teamsSwiper = new Swiper(".teams-swiper", {
		direction: 'horizontal',
			spaceBetween: 20,
			slidesPerView: 1,
	navigation: {
			nextEl: '.teams-swiper-container .custom-next',
			prevEl: '.teams-swiper-container .custom-prev',
		},
			loop: true,
			// Glide time per click in ms. Was 3000 (3s), which felt sluggish.
			speed: 1000,
			// autoplay: {
			// 	delay: 0,
			// 	disableOnInteraction: false,
			// },
			breakpoints: {
				640: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 30,
				},
				1440: {
					slidesPerView: 4,
					spaceBetween: 30,
				}
			},
			on: {
				init: function () {
					setTimeout(function() {
						window.dispatchEvent(new Event('resize'));
					}, 500);
				},
			},
		});

	var luxuryHomesSwiper = new Swiper(".luxury-homes-swiper", {
		direction: 'horizontal',
			// spaceBetween: 20,
			slidesPerView: 1,
	navigation: {
			nextEl: '.luxury-homes-swiper-container .custom-next',
			prevEl: '.luxury-homes-swiper-container .custom-prev',
		},
			loop: true,
			speed: 3000,
			// autoplay: {
			// 	delay: 0,
			// 	disableOnInteraction: false,
			// },
			breakpoints: {
				640: {
					slidesPerView: 1,
					// spaceBetween: 20,
				},
				1024: {
					slidesPerView: 1,
					// spaceBetween: 30,
				},
				1200: {
					slidesPerView: 1,
					// spaceBetween: 30,
				},
				1440: {
					slidesPerView: 1,
					// spaceBetween: 30,
				}
			},
			on: {
				init: function () {
					setTimeout(function() {
						window.dispatchEvent(new Event('resize'));
					}, 500);
				},
			},
		});

		var singlePortfolioSwiper = new Swiper(".single-portfolio-swiper", {
			direction: 'horizontal',
			// spaceBetween: 20,
			slidesPerView: 1,
			navigation: {
				nextEl: '.single-portfolio-swiper-container .custom-next',
				prevEl: '.single-portfolio-swiper-container .custom-prev',
			},
			loop: true,
			speed: 3000,
			// autoplay: {
			// 	delay: 0,
			// 	disableOnInteraction: false,
			// },
			breakpoints: {
				640: {
					slidesPerView: 1,
					// spaceBetween: 20,
				},
				1024: {
					slidesPerView: 1,
					// spaceBetween: 30,
				},
				1200: {
					slidesPerView: 1,
					// spaceBetween: 30,
				},
				1440: {
					slidesPerView: 1,
					// spaceBetween: 30,
				}
			}
		});

	var stepsSwiper = new Swiper(".steps-swiper", {
		direction: 'horizontal',
			spaceBetween: 40,
			slidesPerView: 1,
	navigation: {
			nextEl: '.steps-swiper-container .custom-next',
			prevEl: '.steps-swiper-container .custom-prev',
		},
			loop: true,
			speed: 3000,
			// autoplay: {
			// 	delay: 0,
			// 	disableOnInteraction: false,
			// },
			breakpoints: {
				640: {
					slidesPerView: 1,
					// spaceBetween: 20,
				},
				1024: {
					slidesPerView: 1,
					// spaceBetween: 30,
				},
				1200: {
					slidesPerView: 1,
					// spaceBetween: 30,
				},
				1440: {
					slidesPerView: 1,
					// spaceBetween: 30,
				}
			},
			on: {
				init: function () {
					setTimeout(function() {
						window.dispatchEvent(new Event('resize'));
					}, 500);
				},
			},
		});	
	
		jQuery( "#justMeBox" ).addClass( "financing-box-selected" );
		jQuery( "#myselfAndAnotherBox" ).addClass( "financing-box-unselected" );
		jQuery( "#myselfAndAnotherForm" ).addClass( "hide" );
			jQuery('#justMeButton').on("click",function(){				
				jQuery( "#justMeBox" ).addClass( "financing-box-selected" );
				jQuery( "#justMeBox" ).removeClass( "financing-box-unselected" );
				jQuery( "#myselfAndAnotherBox" ).addClass( "financing-box-unselected" );
				jQuery( "#myselfAndAnotherBox" ).removeClass( "financing-box-selected" );
				jQuery( "#myselfAndAnotherForm" ).addClass( "hide" );
				jQuery( "#justMeForm" ).removeClass( "hide" );
				jQuery( ".img-gradient-one" ).removeClass( "hide" );
				jQuery( ".img-solid-two" ).removeClass( "hide" );
				jQuery( ".img-gradient-two" ).addClass( "hide" );
				jQuery( ".img-solid-one" ).addClass( "hide" );
			});
			jQuery('#myselfAndAnotherButton').on("click",function(){
				jQuery( "#myselfAndAnotherBox" ).addClass( "financing-box-selected" );
				jQuery( "#myselfAndAnotherBox" ).removeClass( "financing-box-unselected" );
				jQuery( "#justMeBox" ).removeClass( "financing-box-selected" );
				jQuery( "#justMeBox" ).addClass( "financing-box-unselected" );
				jQuery( "#justMeForm" ).addClass( "hide" );
				jQuery( "#myselfAndAnotherForm" ).removeClass( "hide" );
				jQuery( ".img-gradient-one" ).addClass( "hide" );
				jQuery( ".img-solid-two" ).addClass( "hide" );
				jQuery( ".img-gradient-two" ).removeClass( "hide" );
				jQuery( ".img-solid-one" ).removeClass( "hide" );
			});
		
});




/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions()
{
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function(){
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */